import { useTranslation } from '@crehana/i18n';
import { CustomNextImage as Image } from '@crehana/next';
// eslint-disable-next-line no-restricted-imports -- Old components are used for compatibility
// biome-ignore lint/style/noRestrictedImports: legacy code - style/noRestrictedImports
import { Col, Container, Row } from '@crehana/ui';
import clsx from 'clsx';

import { imgixLoader } from '@/shared/utils/imgixLoader';

const IMAGE = {
  1: 'https://crehana-vercel-images-prd.imgix.net/public/crehana-frontend-mf/652a433b-c495-4cba-8e92-acc268dc8b04-imagen-pegada-(2).png?auto=format&fit=clip',
  2: 'https://crehana-vercel-images-prd.imgix.net/public/crehana-frontend-mf/13785051-dec1-4b4d-95bc-1750ab308cb5-imagen-pegada.png?auto=format&fit=clip',
  3: 'https://crehana-vercel-images-prd.imgix.net/public/crehana-frontend-mf/9e64ffb7-6e91-418d-b12c-5db3c7f05442-imagen-pegada-(3).png?auto=format&fit=clip',
};

const Features: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { t } = useTranslation();

  return (
    <section className="tw-flex tw-items-start tw-flex-grow tw-mt-2">
      <Container>
        <Row>
          <Col
            className="tw-flex tw-flex-col tw-items-center tw-justify-center"
            xs={12}
            sm={12}
            md={12}
            lg={12}
          >
            <p className="w-full flex justify-center tw-font-h3 tw-text-neutral-dark-800 mb-32">
              {t('FEATURE_TITLE')}
            </p>
            <section>
              <section className="flex flex-col sm:flex-row justify-center mb-24 tw-gap-2.4">
                {[...Array(3)].map((_, i) => (
                  <div
                    key={`features-web-${IMAGE[(i + 1) as keyof typeof IMAGE]}`}
                    className={clsx(
                      'tw-flex tw-flex-col tw-items-start tw-rounded-0.8 shadow-dropdown tw-p-2',
                      'lg:tw-max-w-[302px] lg:tw-max-h-[340px] lg:tw-min-w-[302px] lg:tw-min-h-[340px]',
                      'md:tw-max-w-[264px] md:tw-max-h-[362px] md:tw-min-w-[264px] md:tw-min-h-[362px]',
                      'sm:tw-max-w-[219px] sm:tw-max-h-[406px] sm:tw-min-w-[219px] sm:tw-min-h-[406px]',
                    )}
                  >
                    <div className="tw-flex tw-justify-center tw-w-full">
                      <Image
                        src={IMAGE[(i + 1) as keyof typeof IMAGE]}
                        loader={imgixLoader}
                        layout="intrinsic"
                        width={320}
                        height={180}
                        alt="welcome"
                        loading="lazy"
                        quality={100}
                      />
                    </div>
                    <p className="w-full flex justify-start mt-16 pt-2 mb-8 tw-font-subtitle4 tw-text-neutral-light-800">
                      {t(`FEATURE_TITLE_${i + 1}`)}
                    </p>
                    <p className="w-full flex justify-start tw-font-body4 tw-text-neutral-light-700">
                      {t(`FEATURE_DESCRIPTION_${i + 1}`)}
                    </p>
                  </div>
                ))}
              </section>
              <span className="w-full flex justify-start tw-font-body5 tw-text-neutral-light-700">
                {t('FEATURE_INFO')}
              </span>
            </section>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Features;
